// extracted by mini-css-extract-plugin
export default {"countDownMessage":"emetBreak_countDownMessage__jOHzh"};